import React, { useState } from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from '../Styles/Button.module.css';
import { Link } from "react-router-dom";
import { useSelector } from 'react-redux';
import LoginPopup from "../Common/Login/UserLogin";
const BannerComponent = ()=>{
    const { isAuthenticated, user, token } = useSelector((state) => state.auth);
    const [loginShow, setLoginShow] = useState(false);
    const showLoginHandler=()=>{
        setLoginShow(true)
    }
    const hideLoginHandler = ()=>{
        setLoginShow(false)
    }
    return(
        <section className="home-banner">
            <img className='bannerImg' src={require('../../assest/images/banner-new.JPG')} />
            <div className="photo-text">
                <Container>
                    <Row>
                        <Col>
                            <h2 className="welcome animate">Welcome to the official</h2>
                            <h1 className="heading">Mayo College <span>Alumni website</span></h1>
                            {!isAuthenticated ?
                            <div className="bannerBtn">
                                <button type="button" onClick={showLoginHandler} className={Button.whiteBtn}>Login</button>
                                <Link to='/registration'className={Button.whiteBtn}>REGISTER NOW</Link>
                            </div>
                            : null }
                        </Col>
                    </Row>
                </Container>
            </div>
            {loginShow && <LoginPopup onClose={hideLoginHandler} />}
        </section>        
    )
}

export default BannerComponent;